import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosApiInstance } from "@/helper/axios";
import { API_PORTAL_URL } from "@/lib/config";
import { ErrorToast, SuccessToast } from "@/components/toast/Toasts";
import {
  ITestimonial,
  IInsertTestimonialPayload,
  IUpdateTestimonialPayload,
  IFindAllTestimonialPayload,
  IActiveInActiveTestimonialPayload,
} from "./testimonialModel";

export const findAllTestimonial = createAsyncThunk(
  "Testimonial/FindAllTestimonial",
  async (payload?: IFindAllTestimonialPayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Testimonial/FindAllTestimonial`,
        {
          customerName: payload?.customerName ?? "",
          productID: null,
        },
      );
      const data = response.data?.Data || [];
      return data.map((item: any) => ({
        ID: item.ID || item.id,
        CustomerID: item.CustomerID || item.customerID,
        ProductID: item.ProductID || item.productID,
        CustomerName: item.CustomerName || item.customerName || item.FullName || "",
        Rating: item.Rating ?? item.rating ?? 5,
        Description: item.Description || item.description || "",
        IsActive: item.IsActive !== undefined ? item.IsActive : item.isActive ?? true,
        CreatedBy: item.CreatedBy || item.createdBy,
        CreatedOn: item.CreatedOn || item.createdOn,
        ProductName: item.ProductName || item.productName || "",
      })) as ITestimonial[];
    } catch (error: any) {
      console.error("Error Fetching Testimonials:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findAllActiveTestimonial = createAsyncThunk(
  "Testimonial/FindAllActiveTestimonial",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_PORTAL_URL}/Testimonial/FindAllActiveTestimonial`,
      );
      return (response.data?.Data || []) as ITestimonial[];
    } catch (error: any) {
      console.error("Error Fetching Active Testimonials:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const insertTestimonial = createAsyncThunk(
  "Testimonial/InsertTestimonial",
  async (testimonialData: IInsertTestimonialPayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Testimonial/InsertTestimonial`,
        testimonialData,
      );
      SuccessToast(response.data?.Details || "Testimonial created successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Testimonial:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const updateTestimonial = createAsyncThunk(
  "Testimonial/UpdateTestimonial",
  async (testimonialData: IUpdateTestimonialPayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Testimonial/UpdateTestimonial`,
        testimonialData,
      );
      SuccessToast(response.data?.Details || "Testimonial updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Testimonial:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const findByIDTestimonial = createAsyncThunk(
  "Testimonial/FindByIDTestimonial",
  async (id: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Testimonial/FindByIDTestimonial`,
        { id },
      );
      const result = response.data?.Data as any;
      if (!result) return null;
      return {
        ID: result.ID || result.id || id,
        CustomerID: result.CustomerID || result.customerID || null,
        ProductID: result.ProductID || result.productID || null,
        CustomerName: result.CustomerName || result.customerName || "",
        Rating: result.Rating ?? result.rating ?? 5,
        Description: result.Description || result.description || "",
        IsActive: result.IsActive !== undefined ? result.IsActive : result.isActive ?? true,
      } as ITestimonial;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Testimonial:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const activeInactiveTestimonial = createAsyncThunk(
  "Testimonial/ActiveInActiveTestimonial",
  async (payload: IActiveInActiveTestimonialPayload) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Testimonial/ActiveInActiveTestimonial`,
        payload,
      );
      SuccessToast(response.data?.Details || "Status updated successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error toggling Testimonial status:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const deleteTestimonial = createAsyncThunk(
  "Testimonial/DeleteTestimonial",
  async (id: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_PORTAL_URL}/Testimonial/DeleteTestimonial`,
        { id },
      );
      SuccessToast(response.data?.Details || "Testimonial deleted successfully");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Testimonial:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
